import { render, staticRenderFns } from "./exchange-goods-multiple.vue?vue&type=template&id=cfaab6ae&scoped=true&"
import script from "./exchange-goods-multiple.vue?vue&type=script&lang=js&"
export * from "./exchange-goods-multiple.vue?vue&type=script&lang=js&"
import style0 from "./exchange-goods-multiple.vue?vue&type=style&index=0&id=cfaab6ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaab6ae",
  null
  
)

export default component.exports